/**
 * Get local date from UTC date
 *
 * @param date
 */
export function toLocalFromUTCDate(currentDate: Date): Date {
  return new Date(
    currentDate.getTime() - currentDate.getTimezoneOffset() * 60 * 1000,
  );
}
